import mixins from '~/mixins/global';
import moment from 'moment';
import {NO_TODO_STATE, SUCCESS_STATUS, TODO_STATE} from '~/contants/base';
import {sortByDate} from '~/helpers/common';

export async function getList({commit}, options = {}) {
  let today, startDate, endDate;
  const {noStart, end} = options;
  today = new Date();
  startDate = noStart ? null : mixins.methods.formatDatetime(new Date(today.getFullYear(), today.getMonth(), 1));
  endDate = end || mixins.methods.formatDatetime(today);

  const query = {
    mapType: 2,
    start: startDate,
    end: endDate,
    filterKey: 'is_todo',
    filterValue: 0
  };

  const {errResponse, data: responseData} = await this.$frontendRepositories.proposals.index({
    params: query
  });

  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }

  return [];
}

export async function deleteProposalByEncryptId({commit}, encryptId) {
  const {errResponse} = await this.$frontendRepositories.proposals.deleteProposalByEncryptId(encryptId);

  if(!errResponse) {
    commit('deleteProposal', encryptId);
  }
}

export async function getListByMonth({commit}, payload = {}) {
  let proposals = [];
  let todos = [];
  let year, month;
  year = moment().year();
  month = moment().format('MM');

  if (payload.month) {
    [year, month] = payload.month.split('-');
  }

  let startDate, endDate;
  startDate = mixins.methods.formatDatetime(new Date(year, month - 1, 1));
  endDate = mixins.methods.formatDatetime(new Date(year, month, 0));

  const query = {
    mapType: 2,
    start: startDate,
    end: endDate
  };

  const response = await this.$frontendRepositories.proposals.index({
    params: query
  });

  const {errResponse, data: responseData} = response;

  if (!errResponse && responseData.success) {
    responseData.data.forEach(function (value) {
      if (moment(value.proposal_at).format('MM') === month) {
        if (value.from == 2 && !value.is_todo) {
          proposals.push(value);
        } else {
          switch (value.is_todo) {
            case NO_TODO_STATE:
              proposals.push(value);
              break;
            case TODO_STATE:
              todos.push(value);
              break;
          }
        }
      }
    });
  }

  sortByDate(proposals);
  sortByDate(todos, 'asc', 'proposal_at');

  commit('setListInMonth', proposals);  
  commit('frontend/todo/setList', todos, {root: true});
  commit('setThisMonthProposalTotal', proposals.length);
}

/**
 * @param commit
 * @param dispatch
 * @param state
 * @param {FormData} payload
 *
 * @returns {Promise<*>}
 */
export async function createProposal({commit, dispatch, state}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.proposals.create(payload);
  commit('setCurrentStatus', 0);
  commit('setBtnLoading', false, {root: true});
  return response;
}

/**
 * Update proposal
 *
 * @param dispatch
 * @param commit
 * @param state
 * @param {FormData} payload
 *
 * @returns {Promise<*>}
 */
export async function updateProposal(_, payload) {
  const response = await this.$frontendRepositories.proposals.update(payload.get('id'), payload);
  return response;
}

export async function updateStatusProposal(_, payload) {
  return await this.$frontendRepositories.proposals.updateStatus(payload.id, payload.status);
}

export async function changeProposalToTodo({commit}, id) {
  const payload = new FormData();
  payload.append('id', id);
  payload.append('is_todo', 1);
  payload.append('_method', 'PUT');

  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.proposals.update(payload.get('id'), payload);

  commit('hidePageLoading', payload, {root: true});
  return response;
}

export async function changeProposalStatus({commit}, {id, value}) {
  const payload = new FormData();
  payload.append('id', id);
  payload.append('status', value);
  payload.append('_method', 'PUT');

  commit('showPageLoading', payload, {root: true});
  const response = await this.$frontendRepositories.proposals.update(payload.get('id'), payload);
  commit('hidePageLoading', payload, {root: true});
  return response;
}

export async function findProposalById({commit}, {id, from}) {
  const response = await this.$frontendRepositories.proposals.show(id, {
    params: {
      from
    }
  });
  if (!response.errResponse && response.data.success) {
    commit('setProposal', response.data.data);
  }

  return response;
}

export async function updateTaskStatus(_, payload) {
  return await this.$frontendRepositories.proposals.updateTaskStatus(payload);
}

export async function updateStepStatus(_, payload) {
  return await this.$frontendRepositories.proposals.updateStepStatus(payload);
}

export async function getListUserForAssign({commit}, id) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.proposals.getEmployeeList(id);
  if (!errResponse && responseData.success) {
    return commit('setEmployeeList', responseData.data);
  }
}

export async function getListUserByCompany({commit}) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.proposals.getListUserByCompany();
  if (!errResponse && responseData.success) {
    return commit('setEmployeeList', responseData.data);
  }
}

export async function getCommentsByProposalId({commit, dispatch}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.comments.findByProposalId({params: payload});
  commit('setProposalId', payload.proposal_id);
  commit('setProposalFrom', payload.from);
  if (!errResponse && responseData.success) {
    return commit('setComments', responseData.data);
  }
}

export async function storeComment({commit, dispatch}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.comments.create(payload);
  if (!errResponse && responseData.success) {
    return commit('setComments', responseData.data);
  }
}

export async function deleteComment({commit, dispatch}, payload) {
  const response = await this.$frontendRepositories.comments.delete(payload.id);
  await dispatch('getCommentsByProposalId', payload.body);
  return response;
}

export async function findProposalFromRedisByKey({commit}, key) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.proposals.findProposalFromRedisByKey(key);
  if (!errResponse && responseData.success) {
    return responseData.data;
  }

  return {};
}

export async function assignStep({commit}, payload) {
  commit('setBtnLoading', true, {root: true});

  const response = await this.$frontendRepositories.proposals.assignStep(payload);
  const {errResponse, data: responseData} = response;

  commit('setBtnLoading', false, {root: true});

  if (!errResponse && responseData.success) {
    const data = {
      stepIndex: payload.stepIndex,
      dataUpdate: responseData.data
    }

    commit('particles/step/updateStep', data, {root: true});
  }

  return response;
}

export async function assignTask({commit}, payload) {
  commit('setBtnLoading', true, {root: true});

  const response = await this.$frontendRepositories.proposals.assignTask(payload);
  const {errResponse, data: responseData} = response;

  commit('setBtnLoading', false, {root: true});

  if (!errResponse && responseData.success) {
    const data = {
      stepIndex: payload.stepIndex,
      taskIndex: payload.taskIndex,
      dataUpdate: responseData.data
    }

    commit('particles/step/updateTask', data, {root: true});
  }

  return response;
}

export async function getProposalFromLs({commit}, payload = {}) {
  return this.$frontendRepositories.proposals.getProposalFromLs(payload);
}

export async function getProposalDashboard() {
  return this.$frontendRepositories.proposals.getProposalDashboard();
}

export async function getTodoDashboard({commit}) {
  commit('setInitTodoDashboard', true)
  const response = await this.$frontendRepositories.proposals.getTodoDashboard();
  if (response.data && response.data.success) {
    commit('setTodoDashboard', response.data.data)
    commit('setInitTodoDashboard', false)
  }
  return response
}

export async function getTodoChartDashboard({commit}) {
  const response = await this.$frontendRepositories.proposals.getTodoChartDashboard();
  if (response.data.success) {
    commit('setTodoChartDashboard', response.data.data)
  }
}